import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { toast } from "sonner";

import { fetchMovedAccounts } from "@/actions/movedAccounts";
import { FormControl, FormItem, FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";

interface IImputationProps {
    isPending: boolean;
    value: string | undefined;
}

export const Imputation = ({ value, isPending }: IImputationProps) => {
    const t = useTranslations("expense");

    const {
        data: movedAccounts,
        error,
        isLoading,
    } = useQuery({
        queryKey: [ "movedAccounts" ],
        queryFn: fetchMovedAccounts,
    });

    if (error) {
        toast.error(t("error.fetchMovedAccount"));
        return null;
    }

    if (isLoading) {
        return <Skeleton className="h-[40px] w-full" />;
    }
    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("imputation")} :</FormLabel>
            <FormControl className="w-full md:w-1/2">
                <Input disabled={ isPending } readOnly value={ movedAccounts?.find(movedAccount => movedAccount.id === value)?.name || "" } />
            </FormControl>
        </FormItem>
    );
};
